import { gql } from '@apollo/client';
import {
    NoUpdateDashboardDrillTypeInput,
    NoUpdateStatusInput,
} from '../../types/dashboard/NoUpdateDashboardTypes';

export const GENERATE_NO_UPDATE_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateNoUpdateDetailDownloadReport($filter: NoUpdateDetailDownloadFilterInput!, $timezone: String) {
        generateNoUpdateDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface NoUpdateDetailDownloadFilterInput {
    statDateStart: string;
    statDateEnd: string;
    hubId: number;
    hubIds?: number[] | null;
    drillType: NoUpdateDashboardDrillTypeInput;
    noUpdateStatus?: NoUpdateStatusInput;
    responsibleHubId?: number | null;
    responsibleWarehouseId?: number | null;
    ids?: string[] | null;
}

export interface GenerateNoUpdateDetailDownloadReportVariables {
    filter: NoUpdateDetailDownloadFilterInput;
    timezone?: string;
}

export interface GenerateNoUpdateDetailDownloadReportResponse {
    generateNoUpdateDetailDownloadReport: string;
}
